import RatiosContainer from "./ratios-container"

export default RatiosContainer


// WEBPACK FOOTER //
// ./src/component/ratios/index.js